
import { defineComponent, computed, ref, SetupContext, watchEffect, Ref } from 'vue';

export default defineComponent({
  name: 'TPortrait',
  components: {},
  props: {
    /** 默认文案(如果忽略lang的报错，传入一个不合法的lang，文案就会使用这个值) */
    tips: {
      type: String,
      default: '请调整萤幕方向至直向显示',
    },
    /** 文案的多语言配置信息 */
    lang: {
      type: String,
      default: 'zh-HK',
      validator: (value: string) => ['en-GB', 'zh-CN', 'zh-HK'].includes(value),
    },
  },
  emits: ['click'],
  setup(props, context: SetupContext) {
    /** 组件的className前辍 */
    const prefixCls = ref('t-portrait');
    /** 设置一个map，用于解决版本文案的多语言统一问题 */
    const tipsMap = {
      'en-GB': 'Please rotate your screen to portrait',
      'zh-CN': '请调整萤幕方向至直向显示',
      'zh-HK': '請調整螢幕方向至直向顯示',
    };
    /** 根据多语言，获取对应的文案信息 */
    const getTips = computed(() => {
      const tempLang = props.lang as 'en-GB' | 'zh-CN' | 'zh-HK';
      const output = tipsMap[tempLang];
      return output || props.tips;
    });
    /** 对外响应的事件 */
    const listener = (event: any) => context.emit('click', event);
    /** 模板依赖的className */
    const classes: Ref<string[]> = ref([]);
    /** 获取当前屏幕的旋转角度 */
    const angle = ref(window.orientation);
    /** 监听页面是否处于旋转改变的事件 */
    window.addEventListener('orientationchange', () => (angle.value = window.orientation), false);
    /** 动态监听旋转角度，用于计算特定的className */
    watchEffect(() => {
      // portrait 竖屏
      if (angle.value === 180 || angle.value === 0) {
        classes.value = [prefixCls.value, `${prefixCls.value}__portrait`];
      }
      // landscape 横屏
      if (angle.value === 90 || angle.value === -90) {
        classes.value = [prefixCls.value, `${prefixCls.value}__landscape`];
      }
    });

    return { prefixCls, classes, getTips, listener };
  },
});
